import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Grid from './Grid';
import Cell from './Cell';
import H2 from './H2';
import Block from './Block';
import MailchimpForm from './MailchimpForm';
import Backgrounder from './Backgrounder';
import RichTextHtml from './RichTextHtml';

const PageForm = ({ content }) => (
  <Block
    id={content.internal_link_id}
    backgroundColor="grayLight"
    position="relative"
  >
    <Backgrounder
      backgroundColor={content.text_background_color}
      position={content.text_position}
    />
    <Grid
      valign="center"
      flexDirection={{
        tablet: content.text_position === 'right' ? 'row-reverse' : 'row',
      }}
    >
      <Cell
        py={{ mobile: 'baseUp4', tablet: 'baseUp12' }}
        pl="baseUp4"
        size={{ mobile: 1, tablet: 1 / 2 }}
        backgroundColor={content.text_background_color}
        position="relative"
      >
        <Block px="baseUnit">
          <H2 mb="baseUnit" color={content.title_color}>
            {content.title1.text}
          </H2>

          <RichTextHtml
            html={content.text.html}
            color={content.text_color}
            listStyle={content.text_list_style}
          />
        </Block>
      </Cell>

      <Cell
        py={{ mobile: 'baseUp4', tablet: 'baseUp12' }}
        px={{ mobile: 'baseUnit', tablet: 'baseUp12' }}
        size={{ mobile: 1, tablet: 1 / 2 }}
      >
        <MailchimpForm content={content.form.document.data} />
      </Cell>
    </Grid>
  </Block>
);

PageForm.propTypes = {
  content: PropTypes.shape({
    internal_link_id: PropTypes.string,
    title1: PropTypes.shape({
      text: PropTypes.string,
    }),
    text: PropTypes.shape({
      html: PropTypes.string,
    }),
    title_color: PropTypes.string,
    text_background_color: PropTypes.string,
    text_color: PropTypes.string,
    text_position: PropTypes.string,
    text_list_style: PropTypes.string,
    form: PropTypes.shape({
      document: PropTypes.shape({
        data: PropTypes.shape({}),
      }),
    }),
  }).isRequired,
};

export default PageForm;

export const query = graphql`
  fragment PageFormFragment on PrismicPageDataBodyForm {
    id
    slice_type
    primary {
      internal_link_id
      title1 {
        text
      }
      title_color
      text {
        html
      }
      text_background_color
      text_color
      text_position
      text_list_style
      form {
        document {
          ... on PrismicMailchimpForm {
            ...MailchimpFormFragment
          }
        }
      }
    }
  }
`;
